import React, {useState} from 'react';
import {Form, Upload, Button, message, Card, Alert} from 'antd';
import {InboxOutlined, FileAddOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import {UploadFileMaxSize} from '../../../Util/commonUtility';
import {FETCH_ERROR} from '../../../Constant/ActionTypes';
import {useDispatch} from 'react-redux';
import useLocalization from '../../../Localization';
import './PbssFilesAdd.scss';

const ACCEPT = '.pdf,.jpg,.jpeg,.png';
const ALLOWED_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
];

const PbssFilesAddComponent = ({onUpload, uploading}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {ApplicationString} = useLocalization();
  const [fileList, setFileList] = useState([]);

  const beforeUpload = (file) => {
    const isAllowed = ALLOWED_TYPES.includes(file.type);
    if (!isAllowed) {
      dispatch({
        type: FETCH_ERROR,
        payload: 'Invalid file type. Allowed: PDF, JPG, JPEG, PNG only.',
      });
      return Upload.LIST_IGNORE;
    }
    const isLtMax = file.size / 1024 / 1024 < UploadFileMaxSize;
    if (!isLtMax) {
      dispatch({
        type: FETCH_ERROR,
        payload: `File must be smaller than ${UploadFileMaxSize}MB.`,
      });
      return Upload.LIST_IGNORE;
    }
    setFileList([file]);
    return false; // prevent auto upload
  };

  const onRemove = () => {
    setFileList([]);
  };

  const handleSubmit = async () => {
    if (fileList.length === 0) {
      message.warning('Please select a file to upload.');
      return;
    }
    const formData = new FormData();
    formData.append('file', fileList[0]);
    try {
      await onUpload(formData);
      navigate('/admin/pbssFiles');
    } catch (e) {
      // error already dispatched
    }
  };

  return (
    <div className='pbss-files-add'>
      <Card className='pbss-files-add-card' bordered={false}>
        <Alert
          message='This file will be added for type PBSS International.'
          type='info'
          showIcon
          className='pbss-files-add-note'
        />
        <Form layout='vertical' className='pbss-files-add-form'>
          <Form.Item
            label='Upload file'
            required
            className='pbss-files-add-upload-item'>
            <Upload.Dragger
              name='file'
              multiple={false}
              fileList={fileList.map((f, i) => ({
                uid: f.uid || `${i}`,
                name: f.name,
                status: 'done',
              }))}
              beforeUpload={beforeUpload}
              onRemove={onRemove}
              accept={ACCEPT}
              maxCount={1}
              className='pbss-files-add-dragger'>
              <p className='ant-upload-drag-icon'>
                <InboxOutlined className='pbss-files-add-drag-icon' />
              </p>
              <p className='ant-upload-text'>Click or drag file to this area</p>
              <p className='ant-upload-hint'>
                PDF, JPG, JPEG or PNG · Max {UploadFileMaxSize}MB
              </p>
            </Upload.Dragger>
          </Form.Item>
          <div className='pbss-files-add-actions'>
            <Button size='large' onClick={() => navigate('/admin/pbssFiles')}>
              Cancel
            </Button>
            <Button
              type='primary'
              size='large'
              htmlType='button'
              loading={uploading}
              onClick={handleSubmit}
              disabled={fileList.length === 0}
              icon={<FileAddOutlined />}>
              Upload file
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default PbssFilesAddComponent;
